// extracted by mini-css-extract-plugin
export default {"requiredSymbol":"CustomDatePicker_requiredSymbol__6Gz+2"};